import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const CreateGradingTemplateMutation = graphql.persisted(
  "CreateGradingTemplate",
  graphql(`
    mutation CreateGradingTemplate($input: CreateGradingTemplateInput!) {
      createGradingTemplate(input: $input) {
        gradingTemplate {
          id
          name
          description
          weightTotal
          categories { id name weight dropLowest position }
        }
        userErrors { message path }
      }
    }
  `)
);

const UpdateGradingTemplateMutation = graphql.persisted(
  "UpdateGradingTemplate",
  graphql(`
    mutation UpdateGradingTemplate($input: UpdateGradingTemplateInput!) {
      updateGradingTemplate(input: $input) {
        gradingTemplate {
          id
          name
          description
          weightTotal
          categories { id name weight dropLowest position }
        }
        userErrors { message path }
      }
    }
  `)
);

const DeleteGradingTemplateMutation = graphql.persisted(
  "DeleteGradingTemplate",
  graphql(`
    mutation DeleteGradingTemplate($input: DeleteGradingTemplateInput!) {
      deleteGradingTemplate(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export {
  CreateGradingTemplateMutation,
  UpdateGradingTemplateMutation,
  DeleteGradingTemplateMutation,
};

export function useCreateGradingTemplate() { return useMutation(CreateGradingTemplateMutation); }
export function useUpdateGradingTemplate() { return useMutation(UpdateGradingTemplateMutation); }
export function useDeleteGradingTemplate() { return useMutation(DeleteGradingTemplateMutation); }
